/* eslint-disable */
export enum RequestStatusEnum {
  DRAFT = "DRAFT",
  DRAFT_ASSIGNED = "DRAFT_ASSIGNED",
  SUBMITTED = "SUBMITTED",
  CLOSED = "CLOSED",
  STALLED = "STALLED",
  IN_PROGRESS = "IN_PROGRESS",
  LODGED = "LODGED",
  FINISHED = "FINISHED",
  CANCELLED = "CANCELLED",
  CONNECTED = "CONNECTED",
  NONE = "NONE",
  DISCARDED = "DISCARDED",
  FAILED = "FAILED",
  COMPLETED = "COMPLETED",
  CT_SUBMITTED = "CT_SUBMITTED",
  CT_NOT_REQUIRED = "CT_NOT_REQUIRED",
  PROCESSED = "PROCESSED",
  AWAITING_ACCOUNT_HOLDER = "AWAITING_ACCOUNT_HOLDER",
}

export enum RequestChannelEnum {
  ORIGIN_CONNECT = "ORIGIN_CONNECT",
  CONNECT_ASSIST = "CONNECT_ASSIST",
  NETWORK = "NETWORK",
  MANUAL = "MANUAL",
  UNKNOWN = "UNKNOWN",
  CLAIM = "CLAIM",
}

export enum State {
  ACT = "ACT",
  NSW = "NSW",
  // NT = "NT",
  QLD = "QLD",
  SA = "SA",
  // TAS = "TAS",
  VIC = "VIC",
  // WA = "WA",
}

export enum ServiceTypeEnum {
  ELECTRICITY = "ELECTRICITY",
  GAS = "GAS",
}

export enum AccountPayerEnum {
  COMPANY = "COMPANY",
  SOMEONE_ELSE = "SOMEONE_ELSE",
  ME_MY_COMPANY = "ME_MY_COMPANY",
}

export enum EICStatusEnum {
  EIC_COMM_UNUSED = "EIC_COMM_UNUSED",
  EIC_COMM_NOT_SENT = "EIC_COMM_NOT_SENT",
  EIC_COMM_SENT = "EIC_COMM_SENT",
  EIC_ACCEPTED = "EIC_ACCEPTED",
}

export enum ConnectionTypeEnum {
  PERMANENT = "PERMANENT",
  TEMPORARY = "TEMPORARY",
  TEMPPERM = "TEMPPERM",
  SERVICE_CONNECTION_AND_METER_FIX = "SERVICE_CONNECTION_AND_METER_FIX",
  METER_FIX = "METER_FIX",
  SERVICE_CONNECTION = "SERVICE_CONNECTION",
}

export enum ConnectionTypeFilterOptionEnum {
  PERMANENT = "PERMANENT",
  TEMPORARY = "TEMPORARY",
  TEMPPERM = "TEMPPERM",
  SERVICE_CONNECTION_AND_METER_FIX = "SERVICE_CONNECTION_AND_METER_FIX",
  METER_FIX = "METER_FIX",
  SERVICE_CONNECTION = "SERVICE_CONNECTION",
  CLOSE_ACCOUNT = "CLOSE_ACCOUNT",
  CLOSE_AND_TRANSFER = "CLOSE_AND_TRANSFER",
}

export enum MessageDirectionEnum {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum RequestLifecycle {
  IN_PROGRESS = "IN_PROGRESS",
  BOOKED = "BOOKED",
  COMPLETE = "COMPLETE",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  NMI_REQUESTED = "NMI_REQUESTED",
  NMI_ALLOCATED = "NMI_ALLOCATED",
  CONNECTION_REQUESTED = "CONNECTION_REQUESTED",
  CONNECTED = "CONNECTED",
  SERVICE_LINE_REQUESTED = "SERVICE_LINE_REQUESTED",
  SERVICE_LINE_COMPLETED = "SERVICE_LINE_COMPLETED",
  METER_REQUESTED = "METER_REQUESTED",
}

export type RequestEvent = {
  status: RequestLifecycle;
  eventDate: string;
};

export enum RequestTypeEnum {
  NEW_CONNECTION = "NEW_CONNECTION",
  HANDOVER = "HANDOVER",
  CHANGE_SUPPLY = "CHANGE_SUPPLY",
  REMOVE_SUPPLY = "REMOVE_SUPPLY",
}

export enum OperationalTeamEnum {
  TIER_1 = "TIER_1",
  TIER_2 = "TIER_2",
  TIER_3 = "TIER_3",
  CES = "CES",
  MSBG = "MSBG",
  MSBG_TELCO = "MSBG_TELCO",
  MSBG_COUNCIL = "MSBG_COUNCIL",
}

export type PremiseRequestSummary = {
  service_type: ServiceTypeEnum;
  request_id: string;
  submitted: string;
  expected: string;
  updated: string;
  currentStep: string;
  siteSupervisorName: string;
  nmi_mirn: string;
  request_status: RequestStatusEnum;
  raw_request_status: string;
  accountPayer: AccountPayerEnum;
  connection_type: ConnectionTypeEnum;
  request_type: RequestTypeEnum;
  linkedHandoverRequestId: string;
  latest_message_direction: MessageDirectionEnum;
  latest_message_processed: boolean;
  requestTimeline: RequestEvent[];
  has_unread_message_for_user?: boolean;
  collaborator_name?: string;
  message_pause: boolean;
  journey_id: string | null;
  distributor_application_id: string | null;
  request_channel: RequestChannelEnum | null;
  operational_team: OperationalTeamEnum | null;
  eic_status: EICStatusEnum | null;
};

export enum RequestStatusFilterOption {
  DRAFT = "Draft",
  ASSIGNED = "Assigned",
  RECEIVED = "Received",
  CONNECTION_REQUESTED = "Connection requested",
  CONNECTED = "Connected",
  BOOK_CLOSURE = "Book closure",
  CANCELLED = "Cancelled",
  PAUSED = "Paused",
  UNREAD_MESSAGE = "Unread message",
  ALL_DONE = "All done",
}

export enum RequestStatusFilterEnum {
  IN_PROGRESS = "IN_PROGRESS",
  NEW_MESSAGE = "NEW_MESSAGE",
  REPLY_NEEDED = "REPLY_NEEDED",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  NMI_REQUESTED = "NMI_REQUESTED",
  NMI_ALLOCATED = "NMI_ALLOCATED",
  CONNECTION_REQUESTED = "CONNECTION_REQUESTED",
  CONNECTED = "CONNECTED",
  SERVICE_LINE_REQUESTED = "SERVICE_LINE_REQUESTED",
  METER_REQUESTED = "METER_REQUESTED",
  DRAFT = "DRAFT",
  DRAFT_ASSIGNED = "DRAFT_ASSIGNED",
  FINISHED = "FINISHED",
}

export type RequestFilter = {
  state?: string[];
  status?: string[];
  serviceType?: string[];
  requestType?: string[];
  operationalTeam?: string[];
  requestingCompanyId?: string;
  projectId?: string[];
  createdFrom?: Date;
  createdTo?: Date;
  siteSupervisorName?: string[];
  collaboratorId?: string[];
};

export interface PremiseDetails {
  id: string;
  unit_type: string;
  unit_number: string;
  floor_type?: string;
  floor_number: string;
  site_details: SiteDetails;
}

export const OPERATIONAL_TEAM_FILTER_OPTIONS = [
  "Tier 1",
  "Tier 2",
  "Tier 3",
  "CES",
  "MSBG - Council",
  "MSBG - Telco",
];

export const REQUEST_TYPE_FILTER_OPTIONS = [
  "Permanent",
  "Temp in perm",
  "Temporary",
  "Service line and meter",
  "Meter",
  "Service line",
  "Close account",
  "Close and transfer",
];

export type SiteDetails = {
  id: string;
  street_number?: string;
  lot_number?: string;
  dp_number?: string;
  block_number?: string;
  section_number?: string;
  street_suffix?: string;
  building_name?: string;
  street_name: string;
  street_type: string;
  suburb: string;
  state: State;
  postcode: string;
};

export interface PremiseRequest {
  premise: PremiseDetails;
  premise_request_summary: PremiseRequestSummary;
}

export type PremisesTableRow = {
  serviceType: ServiceTypeEnum;
  connectionType: ConnectionTypeEnum;
  address: string;
  id: string;
  nmi: string;
  lodgedDate: string | null;
  updatedDate: string | null;
  status: string;
  statusText: string;
  hasUnreadMessage: boolean | null;
  journeyId: string | null;
  distributorApplicationId: string | null;
  requestStatus: RequestStatusEnum;
  state: State;
  requestChannel: RequestChannelEnum | null;
  operationalTeam: string;
  eicStatus: EICStatusEnum | null;
  premiseId?: string | null;
};

export type PremisesTableRows = PremisesTableRow[];
/* eslint-enable */

export enum SortDirectionEnum {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SortByEnum {
  SERVICE_TYPE = "SERVICE_TYPE",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  REQUEST_ID = "REQUEST_ID",
  SUBMITTED = "SUBMITTED",
  UPDATED = "UPDATED",
  REQUEST_STATUS = "REQUEST_STATUS",
  RAW_REQUEST_STATUS = "RAW_REQUEST_STATUS",
  ADDRESS = "ADDRESS",
  MESSAGE = "MESSAGE",
}
export enum PropertyType {
  RESIDENTIAL = "RESIDENTIAL",
  COMMERCIAL = "COMMERCIAL",
}

export interface FetchPremisesRequest {
  page?: number;
  limit?: number;
  sortDirection?: SortDirectionEnum;
  sortBy?: SortByEnum;
  incremental?: boolean;
}
